import { ShieldCheck, Code2, Cloud, Headset, Handshake } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";

const ICONS = [ShieldCheck, Code2, Cloud, Headset, Handshake];

export default function WhyChoose() {
  const { t } = useLang();
  const items = t("why_items");

  return (
    <section
      id="why-kinos"
      data-testid="why-choose-section"
      className="bg-[#F8FAFC] text-slate-600 px-6 md:px-12 lg:px-24 py-20 lg:py-28"
    >
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <p className="text-xs tracking-[0.25em] uppercase text-[#ED1C24] mb-4">
                {t("why_label")}
              </p>
              <h2 className="font-display font-semibold text-slate-900 text-4xl sm:text-5xl leading-tight tracking-tight">
                {t("why_title").replace("?", "")}<span className="text-[#ED1C24]">?</span>
              </h2>
              <div className="w-16 h-1 bg-gradient-to-r from-[#ED1C24] to-[#FFC61A] mt-8" />
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ul className="divide-y divide-slate-200">
            {(Array.isArray(items) ? items : []).map((item, i) => {
              const Icon = ICONS[i] || ShieldCheck;
              return (
              <Reveal key={item} delay={i * 0.12}>
                <li
                  data-testid={`why-item-${i}`}
                  className="group flex items-center gap-5 py-7 px-2 -mx-2 hover:bg-white transition-colors duration-300"
                >
                  <span className="w-12 h-12 shrink-0 border border-slate-200 bg-white flex items-center justify-center text-[#ED1C24] transition-colors duration-300 group-hover:bg-[#ED1C24] group-hover:border-[#ED1C24] group-hover:text-white">
                    <Icon
                      size={22}
                      className="transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-110"
                    />
                  </span>
                  <span className="font-display font-semibold text-slate-900 text-xl sm:text-2xl tracking-tight transition-transform duration-300 group-hover:translate-x-1">
                    {item}
                  </span>
                </li>
              </Reveal>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
